import axios from "axios";

axios.defaults.timeout = 600000;
// axios.defaults.timeout = 4000;
import {
  getToken,
  removeToken,
  setToken,
  getBrowserLang
} from "./util.js";
import store from "@/store";
import {Message} from 'view-design';
import Vue from 'vue'
// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []
let v = new Vue();
// console.log('getBrowserLang()',getBrowserLang())
class HttpRequest {
  constructor(baseUrl = '') {
    this.baseUrl = baseUrl;
    this.loader = null;
    this.pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
  }

  getInsideConfig(e) {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        authorization: getToken(),
        "Accept-Language": getBrowserLang() === 'zh' ? 'zh' : 'en',
      }
    };
    return config;
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        // 添加断开请求的方法---------------------这里为重点-----------------------------
        config['cancelToken'] = new axios.CancelToken(function executor(cancel) {
          Vue.$httpRequestList.push(cancel) //存储cancle
        })
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        const {
          data,
          status
        } = res;
        if (status == 200) {
          if (data.code == "ATE") {  //token 过期
            // token过期
            if (!isRefreshing) {
              isRefreshing = true
              return this.refreshToken().then(res => {
                // const { token } = res.data
                let params = getToken()
                removeToken()
                params.LyncmedAccessToken = res.data
                setToken(params);
                url.headers.token = res.data
                requests.forEach(cb => cb(res.data))
                // 重试完了别忘了清空这个队列
                requests = []
                return instance.request(url)
              }).finally(() => {
                isRefreshing = false
              })
            } else {
              // 正在刷新token，返回一个未执行resolve的promise
              return new Promise((resolve) => {
                // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
                requests.push((token) => {
                  url.baseURL = ''
                  url.headers['token'] = token
                  resolve(instance(url))
                })
              })
            }

          } else if (data.code == "RTE") {  //刷新token 过期
            return store._actions.logoutAction[0]()
          } else if (data.code == "ATI" || data.code == 'RTI') { //token 无效
            // return Message.error('身份验证无效');
            return store._actions.logoutAction[0]()
          } else {
            return {
              data,
              status
            };
          }
        }
        return

      },
      error => {
        // console.log('error',error)
        if (error && error.response && error.response.status) {
          //如果出现401错误会清空token
          if (!error.response) {
          } else if (error.response.status === 401) {
            store._actions.logoutAction[0]()
            Message.error(error.response.data.message)
            return Promise.reject(error.response.data);
          } else if (error.response.data)
            if (error.response.config.url.indexOf('member/login') == -1) {
              // 对响应错误做点什么
              Message.warning({
                content: error.response.data.message,
                duration: 10,
                closable: true
              });
            }
          return Promise.reject(error.response.data);
        }
      },
    );
  }

  refreshToken() {
    // instance是当前request.js中已创建的axios实例
    return store._actions.refreshAction[0](getToken().refreshToken).then(res => res)
  }

  request(options) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance, options);
    return instance(options);
  }
}

export default HttpRequest;



// WEBPACK FOOTER //
// ./src/libs/axios.js